export const SubAbasActs = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/proaq/acts/${id}/dadosgerais`,
  },
  {
    label: 'Destaques',
    rota: `/daf/proaq/acts/${id}/destaques`,
  },
];

export const SubAbasActsNovo = [
  {
    label: 'Dados Gerais',
    rota: `/daf/proaq/acts/dadosgerais`,
  },
];
